'use client';

import { PageContainer, PageHeader, StateKit } from '@statura/ui';
import type { ReactNode } from 'react';
import { useUnifiedIncidentCaptureAdmission } from '@/hooks/useUnifiedIncidentCaptureAdmission';
import { useModules } from '@/contexts/module-context';
import { isDashboardProductionSurfaceVisibleForTenant } from '@/lib/production-surface-access';

/** Mounted only at the capture pathname. Other shell paths do not subscribe
 * to this feature query or change their existing role/module gate lifecycle. */
export function UnifiedIncidentCaptureAdmissionGate({
  children,
  legacy,
  requireModuleAccess = false,
}: {
  children: ReactNode;
  legacy: ReactNode;
  requireModuleAccess?: boolean;
}) {
  const admission = useUnifiedIncidentCaptureAdmission(requireModuleAccess);
  const { tenantId, isDemoTenant, isSubscriptionBlocked, modulesLoaded, moduleLoadError } =
    useModules();
  if (requireModuleAccess && isSubscriptionBlocked) return legacy;
  if (admission.pending || admission.modulePending)
    return (
      <PageContainer className="space-y-6">
        <PageHeader title="Report an incident" />
        <StateKit state="checking" label="Opening incident report…" />
      </PageContainer>
    );
  if (
    admission.allowed &&
    (!requireModuleAccess ||
      (modulesLoaded && !moduleLoadError && !isSubscriptionBlocked && admission.moduleAllowed)) &&
    isDashboardProductionSurfaceVisibleForTenant('/compliance/incidents/new', {
      tenantId,
      isDemo: isDemoTenant,
    })
  )
    return <>{children}</>;
  return legacy;
}
